import createSvgIcon from '../Utils/CreateSvgIcon';

export const Video = createSvgIcon(
  <path
    d="M5 5L19 5L19 19H5V5ZM3 3L5 3L19 3H21V5L21 19L21 21H19H5H3V19V5V3ZM16 12L10 16V8L16 12Z"
    fillRule="evenodd"
  />,
  'Video',
);
